import React from 'react';
import '../App.css';

function Home() {
  return (
    <div className="home home--black">
      <header className="home__hero">
        <div className="home__hero-content">
          <img
            src={`${process.env.PUBLIC_URL}/IMMERSION CONSULTING GROUP NOIR.png`}
            alt="Immersion Consulting Group"
            className="home__logo"
          />
          <div className="home__links">
            <a href="/surveys" className="btn btn--primary">
              Participer
              <span className="btn__arrow">&rarr;</span>
            </a>
            <a href="/results" className="btn btn--outline">
              Voir les résultats
            </a>
          </div>
        </div>
      </header>
    </div>
  );
}

export default Home;
